import React from "react";

const Riwayat = () => {
  let tabledata = [
    { name: "Bimbel Mandiri-1", jumlah: "500", nominal: "Rp.500.5000" },
    { name: "Bimbel Mandiri-2", jumlah: "400", nominal: "Rp.1.500.5000" },
    { name: "Bimbel Mandiri-3", jumlah: "300", nominal: "Rp.50.000" },
    { name: "Bimbel Mandiri-4", jumlah: "200", nominal: "Rp.100.000" },
    { name: "Bimbel Mandiri-5", jumlah: "100", nominal: "Rp.100.000" },
  ];
  let tabledata2 = [
    {
      name: "harry.potter@mgail.com",
      nominal: "Rp.500.5000",
      date: "1 Juli 2020",
    },
    {
      name: "harry.potter@mgail.com",
      nominal: "Rp.1.500.5000",
      date: "1 Juli 2020",
    },
    {
      name: "harry.potter@mgail.com",
      nominal: "Rp.50.000",
      date: "1 Juli 2020",
    },
    {
      name: "harry.potter@mgail.com",
      nominal: "Rp.100.000",
      date: "1 Juli 2020",
    },
    {
      name: "harry.potter@mgail.com",
      nominal: "Rp.100.000",
      date: "1 Juli 2020",
    },
  ];

  return (
    <div class="riwaya-penjualan">
      <div class="table">
        <div class="inner">
          <h4>Rewayat Penjualan</h4>
          <select name="" id="">
            <option value="">60 hari terakhir</option>
          </select>
        </div>
        <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Email</th>
              <th>Total Bayar</th>
              <th>Tanggal</th>
            </tr>
          </thead>
          <tbody>
            {tabledata2.map((datas, index) => (
              <tr key={index}>
                <td>{datas.name}</td>
                <td>{datas.nominal}</td>
                <td>{datas.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        <div class="pagination">
          <ul class="page">
            <li>
              <i class="active list_icon material-icons">arrow_back_ios</i>
            </li>
            <li className="activ">1</li>
            <li>2</li>
            <li>3</li>
            <li>...</li>
            <li>10</li>
            <li>
              <i class="active list_icon material-icons">arrow_forward_ios</i>
            </li>
          </ul>
        </div>
      </div>
      <div class="table">
        <div class="inner">
          <h4>Produk Terlaris</h4>
          <select name="" id="">
            <option value="">Produk Terlaris</option>
          </select>
        </div>
        <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>NAMA </th>
              <th>JUMLAH</th>
              <th>NOMINAL</th>
            </tr>
          </thead>
          <tbody>
            {tabledata.map((datas, index) => (
              <tr key={index}>
                <td>{datas.name}</td>
                <td>{datas.jumlah}</td>
                <td>{datas.nominal}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        <div class="pagination">
          <ul class="page">
            <li>
              <i class="active list_icon material-icons">arrow_back_ios</i>
            </li>
            <li className="activ">1</li>
            <li>2</li>
            <li>3</li>
            <li>...</li>
            <li>10</li>
            <li>
              <i class="active list_icon material-icons">arrow_forward_ios</i>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Riwayat;
